module.exports = __webpack_public_path__ + "img/news_title.ad4fd643.png";